export default __webpack_public_path__ + "static/media/13.bb35df47.jpeg";